import { removeParam } from './url';
import MemoryManager from './memoryManager';
import { isNotEmpty } from './check';
import { Icon } from '@beisen/chaos-ui';
//获取window.BSGlobal的值
export const getBSGlobal = (name = '') => {
    return window.BSGlobal && window.BSGlobal[name];
};
export const platformWindow = window.top !== window ? window.top : window;
export const getEnv = () => {
    return platformWindow.env || {};
};
//获得当前语言
export const getI18NUserLang = () => {
    const I18NInfo = getBSGlobal('I18NInfo');
    return I18NInfo ? I18NInfo.I18NUserLang : 'zh_CN';
};
//用于处理降域
export const reducedDomain = () => {
    //降域
    const BSGlobalDomain = getBSGlobal('domain');
    if (BSGlobalDomain) {
        document.domain = BSGlobalDomain;
    }
};
export function isImage(name) {
    let ext = (/[.]/.exec(name) ? /[^.]+$/.exec(name.toLowerCase()) : '')[0];
    let fileType = [
        'jpeg',
        'JPEG',
        'jpg',
        'JPG',
        'gif',
        'GIF',
        'png',
        'PNG',
        'bmp',
        'BMP'
    ];
    if (ext && fileType.includes(ext)) return true;
    return false;
}

export function parseQueryParams(paramStr) {
    let query = {};
    const paramsArr = paramStr.split('&');
    for (let paramPair of paramsArr) {
        let kv = paramPair.split('=');
        query[kv[0]] = kv[1];
    }
    return query;
}

export function createQueryObject(hash) {
    const idx = hash.indexOf('#');
    let queryObj = {
        hashname: '',
        query: {}
    };
    if (idx !== -1) {
        let beginIdx = idx;
        let queryIndex = hash.indexOf('?');
        if (queryIndex !== -1) {
            queryObj.hashname = hash
                .substring(beginIdx, queryIndex)
                .replace(/[#\/]/g, '');
            queryObj.query = parseQueryParams(hash.substring(queryIndex + 1));
        } else {
            queryObj.hashname = hash.substring(beginIdx);
        }
    }
    return queryObj;
}

/**
 * 补全url,在web端采用location对象中的信息补全，
 * 如果当前是运行在apicloud的缓存页中，根据当前页面对应的远程页面的协议等信息进行补全
 *
 * @param  { string } url 将要跳转的url
 */
export function urlCompletion(url) {
    let locationObj = location;
    url = url.trim();
    if (url.startsWith('http')) {
        return url;
    }
    //补全url
    if (url.startsWith('#/') || url.startsWith('#')) {
        url =
            locationObj.origin +
            locationObj.pathname +
            locationObj.search +
            url;
    } else if (url.startsWith('//')) {
        url = locationObj.protocol + url;
    } else if (url.startsWith('/')) {
        url = locationObj.origin + url;
    } else if (!url.startsWith('http') && url.startsWith(location.hostname)) {
        url = locationObj.protocol + '//' + url;
    } else {
        url = locationObj.origin + '/' + url;
    }
    return url;
}

export function triggerBeforeUnload(direction) {
    if (
        direction === 'back' &&
        (!window.events || !window.events['beforeUnload'])
    ) {
        return;
    }
    if (!window._events || !window._events['beforeUnload']) {
        return;
    }
    const url = removeParam('_k', location.href);
    window._events['beforeUnload'].forEach(item => {
        if (url === item.key) {
            item.callback(url, direction);
        }
    });
}

export function ajaxUrlCompletionInCachePage(url) {
    url = url.trim();
    return url;
}
//是否是italent的url
function isItalentUrl(url = '') {
    return (
        url.startsWith('#') ||
        url.startsWith('/#') ||
        url.indexOf('italent') !== -1 ||
        //上海labs环境
        url.indexOf('beisen') !== -1
    );
}
// 在url上添加shadow_context参数
// @url: 目标链接
// @componentApi: boolean 是否为组件内部接口
export const addShadowContextUrl = function(url, componentApi) {
    let shadowContext = '';
    // 判断url上是否有此参数，没有则添加, 有则直接返回url
    const urlArr = url.split('&');
    urlArr.length > 0 &&
        urlArr.map(urlItem => {
            if (urlItem.indexOf('shadow_context=') >= 0) {
                return url;
            }
        });
    // 我们自己的链接及所有接口需要添加此参数
    if (isItalentUrl(url) || url.indexOf('upass') !== -1 || componentApi) {
        const splitIndex = window.location.hash.indexOf('?') + 1;
        let locationHash = splitIndex
            ? window.location.hash.slice(splitIndex)
            : window.location.hash;
        const hashArr = locationHash.split('&');
        hashArr.length > 0 &&
            hashArr.map(hashItem => {
                if (hashItem.indexOf('shadow_context=') >= 0) {
                    shadowContext = hashItem;
                }
            });
    }
    if (shadowContext) {
        const lastRouteIndex = url.lastIndexOf('#');
        const urlSub = lastRouteIndex >= 0 ? url.substring(lastRouteIndex) : '';
        //有些链接路由在最后面会报错
        if (lastRouteIndex >= 0 && urlSub.indexOf('?') < 0) {
            return url + '?' + shadowContext;
        }
        if (url.indexOf('?') >= 0 && urlSub.indexOf('?') > 0) {
            url = url + '&' + shadowContext;
        } else {
            url = url + '?' + shadowContext;
        }
    }
    return url;
};

export const clearLocalStorage = function(localKey) {
    for (let i = 0; i < localStorage.length; i++) {
        let key = localStorage.key(i);
        if (key && key.indexOf(localKey) > -1) {
            localStorage.removeItem(key);
            i--;
        }
    }
};

function addFromDetail(url) {
    if (isItalentUrl(url)) {
        if (url.indexOf('fromURL=homedetail') < 0) {
            if (url.indexOf('?') > -1) {
                url = url + '&fromURL=homedetail';
            } else {
                url = url + '?fromURL=homedetail';
            }
        }
    }
    return url;
}

function createWindowName(url) {
    const hashEncode = encodeURIComponent(urlCompletion(url));
    const windowName =
        hashEncode.replace(/\W/g, '') + BSGlobal.loginUserInfo['Id'];
    return windowName;
}

export function openLinkInDingTalk(url) {
    window.dd.ready(() => {
        window.dd.biz.util.openLink({
            url: url,
            onSuccess: function(result) {},
            onFail: function() {}
        });
    });
}

// 图片预览
export function picPreview(url) {
    triggerBeforeUnload('forward'); //列表位置记忆功能公共方法
    window.env.platform.select({
        beisenApp() {
            platformWindow.env.openNewPage({
                url: url,
                winAttrs: {
                    slidBackEnabled: false
                },
                navBar: {
                    show: false
                }
            });
        },
        mobile() {
            if (window.env.platform.dingTalk) {
                openLinkInDingTalk(url);
                return;
            }
            if (window.parent !== window) {
                window.parent.location.href = url;
                return;
            }
            window.open(url, '_blank');
        }
    });
}

/**
 *
 * @param {*} url  跳转的连接地址
 * @param {*} options isReview  是否是图片预览页 ,useNativeWebView 是否使用原生的webview  ,nativeWebViewOptions  原生webview的相关设置条件, hasShadowContext 是否追加shadow_context参数
 *
 */
export function pageJump(
    url,
    options = {
        openModel: '',
        isCustomLink: false,
        isReplace: false,
        isReview: false,
        useNativeWebView: false,
        nativeWebViewOptions: {
            title: '',
            isShowNav: true,
            isShowProgressView: true,
            isShowDocumentTitle: true,
            isShowCloseBtn: true
        },
        hasShadowContext: true
    }
) {
    // TESTING 目前WK内核处于测试阶段,只对beisenCloudDemo应用起作用,并且图片预览不起作用
    //const useWk = window.BSGlobal.application === 'BeisenCloudDemo' && !options.isReview ? true : false;
    let completedUrl = urlCompletion(url);
    const isOurUrl = isItalentUrl(completedUrl);
    //移除URL的random key
    let reactRouterRandomIndex = completedUrl.indexOf('&_k=');
    if (
        reactRouterRandomIndex > 0 &&
        completedUrl.slice(reactRouterRandomIndex).indexOf('&') < 0
    ) {
        completedUrl = completedUrl.slice(0, reactRouterRandomIndex);
    }
    // 页面跳转需要添加shadow_context参数
    completedUrl = options.hasShadowContext
        ? addShadowContextUrl(completedUrl)
        : completedUrl;
    completedUrl = addFromDetail(completedUrl);
    const windowName = createWindowName(completedUrl);
    if (options.isReview) {
        this.picPreview(completedUrl);
        return;
    }

    if (options.isReplace) {
        const winEnvPlatform = window.env & window.env.platform;
        if (
            winEnvPlatform.dingTalk &&
            winEnvPlatform.android &&
            history.replaceState
        ) {
            history.replaceState(null, document.title, completedUrl);
            history.go(0);
            return null;
        }
        window.location.replace(completedUrl);
        return;
    }
    window.env.platform.select({
        iosApp() {
            //如果是第三方h5页面,则使用native的webview环境打开,因为ios打开的是原生的webView,所以不需要通知他们导航的样式
            if (options.useNativeWebView) {
                window.env.openBSWkWebView({
                    url: completedUrl, //链接  带协议
                    title: options.nativeWebViewOptions.title || '', //默认title
                    isShowNav: options.nativeWebViewOptions.isShowNav, //显示头部
                    isShowProgressView:
                        options.nativeWebViewOptions.isShowProgressView, // 显示头部进度条
                    isShowDocumentTitle:
                        options.nativeWebViewOptions.isShowDocumentTitle, // 是否获取远程页面title
                    isShowCloseBtn: options.nativeWebViewOptions.isShowCloseBtn //是否显示关闭按钮
                });
                return;
            }
            triggerBeforeUnload('forward');
            window.env.openNewPage({
                url: completedUrl,
                pageId: windowName,
                tag: window.env.getPageParam().closeToWinName
            });
        },
        androidApp() {
            if (!isOurUrl || options.isCustomLink) {
                window.env.openNewPage({
                    url: completedUrl
                });
                return;
            }
            triggerBeforeUnload('forward');
            window.location.href = completedUrl;
        },
        mobile() {
            if (options.openModel === '_blank') {
                if (window.env.platform.dingTalk) {
                    openLinkInDingTalk(completedUrl);
                    return;
                }
                window.open(completedUrl, '_blank');
            } else {
                triggerBeforeUnload('forward');
                window.location.href = completedUrl;
            }
        }
    });
}
export const redirectApp = function(evt) {
    evt && evt.preventDefault && evt.preventDefault();
    MemoryManager.removeItem(location.href);
    clearLocalStorage('-viewName');
    window.env.platform.select({
        beisenApp() {
            window.env.closeAll();
        },
        mobile() {
            if (
                BSGlobal.tenantInfo.Id === 105688 ||
                BSGlobal.tenantInfo.Id === 105652
            ) {
                window.location.href =
                    BSGlobal.apiPath +
                    BSGlobal.loginUserInfo.Id +
                    '/UpaasMobileHome';
                return;
            }
            if (BSGlobal.application === 'ELearning') {
                pageJump('#portal?');
                return;
            }
            pageJump('#/index?');
        }
    });
};

export function pageReload() {
    window.location.reload();
}
//页面返回方法
export function handleBack(evt) {
    evt && evt.preventDefault && evt.preventDefault();
    window.env.platform.select({
        beisenApp() {
            window.env.goBack();
        },
        mobile() {
            window.history.go(-1);
        }
    });
}

export function addQuerytoUrl(url, queryObj) {
    const queryIndex = url.indexOf('?');
    let urlHashName = '';
    let urlParams = url;
    if (queryIndex !== -1) {
        urlHashName = url.substring(0, queryIndex + 1);
        urlParams = parseQueryParams(url.substring(queryIndex + 1));
    } else {
        urlParams = parseQueryParams(url);
    }
    const allQuery = Object.assign({}, queryObj, urlParams);
    let queryArr = [];
    for (let key in allQuery) {
        const string = key + '=' + allQuery[key];
        queryArr.push(string);
    }
    return urlHashName + queryArr.join('&');
}

export function isNeedClose() {
    if (window.env.platform.beisenApp) {
        return true;
    }
    const appName = BSGlobal.application;
    const appList = [
        'ApprovalCentre',
        'TenantBase',
        'Attendance',
        'Compensation',
        'Redeem',
        'JobsLink'
    ];
    return appList.indexOf(appName) < 0;
}

export function getAPI(apiName) {
    if (window._beisenCloudApi) {
        return window._beisenCloudApi[apiName];
    }
    return null;
}

export function getCurrentApplicationName() {
    if (window.BSGlobal && window.BSGlobal.hasOwnProperty('application')) {
        return window.BSGlobal.application;
    }
    return null;
}
export function guid() {
    function S4() {
        return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
    }
    return (
        S4() +
        S4() +
        '-' +
        S4() +
        '-' +
        S4() +
        '-' +
        S4() +
        '-' +
        S4() +
        S4() +
        S4()
    );
}

export function getQueryObject() {
    let url = location.href;
    let hash = url.replace(/^(.+)\?(.+)$/gi, '$2').split('&');
    let obj = {};
    hash.map(query => {
        let couple = query.split('=');
        obj[couple[0]] = couple[1];
    });
    if (obj.shadow_context) {
        obj.shadow_context = obj.shadow_context;
    }
    delete obj['_k'];
    return obj;
}

// 获取功能按钮配置中的ajaxList buttonData: {cmp_data:'ddd',cmp_id: 'sss'}  key: 'ajaxUrl'/'formSaveUrl'
export function getAjaxListParams(buttonData, key) {
    if (buttonData && buttonData.cmp_data) {
        const cmpData = buttonData.cmp_data;
        if (cmpData.ajaxList && cmpData.ajaxList.length > 0) {
            let params = null;
            cmpData.ajaxList.map(item => {
                if (item.key.toLowerCase() == key.toLowerCase()) {
                    item['featureId'] = buttonData.cmp_id;
                    params = item;
                }
            });
            return params;
        }
    }
    return null;
}
// 获取需要添加进请求header中的参数
export function getFeatureToken(ajaxParams) {
    return JSON.stringify({
        featureId: ajaxParams.featureId,
        apiCode: ajaxParams.apiCode,
        token: ajaxParams.token
    });
}
/*
iOS中使用new Date(); 传入的数值
2017/08/15 12:09:09 需用斜杠连接
2017-08 需用横杠连接
其余横杠斜杠均可
*/
export function covertDateStrForNewDate(dateStr, type) {
    const dateType = type.toLowerCase();
    switch (dateType) {
        case 'yyyy/mm/dd hh:mm:ss':
            return dateStr.replace(/-/g, '/');
        case 'yyyy/mm':
            return dateStr.replace(/\//g, '-');
        default:
            return dateStr;
    }
}

// 判断是否要隐藏弹层的头部,只有android和ios设备上隐藏头部,这两种设备会把头用壳去显示
export function ifHidePopupNav() {
    return window.env.platform.beisenApp;
}
//存储页面的headerconfig信息
export function setBaseHeaderConfig(headerConfig) {
    window.top.BaseHeaderConfig = headerConfig;
}
// 获取页面headerconfig信息
export function getBaseHeaderConfig() {
    return window.top.BaseHeaderConfig;
}
//删除页面headerconfig信息
export function removeBaseHeaderConfig() {
    window.top.BaseHeaderConfig = undefined;
}
// 存储弹层的headerConfig信息
export function setPopupHeaderConfig(headerConfig) {
    let newConfig = JSON.stringify(headerConfig);
    if (
        window.top.PopupHeaderConfig &&
        window.top.PopupHeaderConfig.length > 0
    ) {
        if (
            window.top.PopupHeaderConfig[
                window.top.PopupHeaderConfig.length - 1
            ] !== newConfig
        ) {
            window.top.PopupHeaderConfig.push(newConfig);
        }
    } else {
        if (JSON.stringify(getBaseHeaderConfig()) !== newConfig) {
            window.top.PopupHeaderConfig = [JSON.stringify(headerConfig)];
        }
    }
}
// 获取弹层页面的headerConfig
export function getPopupHeaderConfig() {
    if (
        window.top.PopupHeaderConfig &&
        window.top.PopupHeaderConfig.length > 0
    ) {
        return JSON.parse(
            window.top.PopupHeaderConfig[
                window.top.PopupHeaderConfig.length - 1
            ]
        );
    } else {
        //表示当前页面不是弹层页面
        window.top.inPopup = false;
        return getBaseHeaderConfig();
    }
}
// 设置壳的头部
// force 表示由于某些特殊需求,即使不是在弹层的情况下也要调用该方法,用来通知壳子更新头部
export function setBoxHeader(headerConfig, force = false) {
    if (ifHidePopupNav() || force) {
        const config = Object.assign({}, headerConfig);
        window.env.platform.select({
            beisenApp() {
                window.top.env.configNavigation(config, ret => {
                    const itemData = ret && ret.data;
                    if (!itemData) return;
                    const { callback, control } = itemData;
                    if (control && callback) {
                        const cb =
                            window.globalEventManager[callback] ||
                            window.top.globalEventManager[callback];
                        cb && cb();
                    }
                });
            }
        });
        setPopupHeaderConfig(config);
    }
}
// 组装设置弹层的头部对象信息
// setHeader 表示由于某些特殊需求,即使不是在弹层的情况下也要调用该方法,用来通知壳子更新头部
export function generateHeaderConfig(callback, setHeader = false) {
    setHeader ? (window.top.inPopup = false) : (window.top.inPopup = true); //表示当前页面是弹层页面
    let headerConfig = getBaseHeaderConfig();
    headerConfig = Object.assign({}, headerConfig);
    headerConfig.leftItem = headerConfig.rightItem = [];
    let conf = callback(headerConfig, function(direct, item, config) {
        config = Object.assign({}, config);
        if (direct === 'left') {
            config.leftItem = item;
        } else {
            config.rightItem = item;
        }
        return config;
    });
    conf.isDialogTitle = true;
    conf.leftItem.forEach(function(item) {
        if (
            (item.lable && item.lable.length > 0) ||
            (item.text && item.text.length > 0)
        ) {
            item.type = 'text';
            item.style = {
                color: '#007ed9'
            };
        }
    });
    conf.rightItem.forEach(function(item) {
        if (
            (item.lable && item.lable.length > 0) ||
            (item.text && item.text.length > 0)
        ) {
            item.type = 'text';
            item.style = {
                color: '#007ed9'
            };
        }
    });
    //new version
    conf.titleItem.style = {
        color: '#3A4247'
    };
    conf.bgColor = '#fafafa';
    conf.color = '#3A4247';
    setBoxHeader(conf, setHeader);
}

export function deletLastHeader() {
    window.top.PopupHeaderConfig &&
        window.top.PopupHeaderConfig.splice(
            window.top.PopupHeaderConfig.length - 1,
            1
        );
}

//清除当前弹层的头部对象并设置前一个对象为壳子的设置对象
export function clearHeaderConfig() {
    window.top.PopupHeaderConfig &&
        window.top.PopupHeaderConfig.splice(
            window.top.PopupHeaderConfig.length - 1,
            1
        );
    let config = getPopupHeaderConfig();
    setBoxHeader(config);
}
//在报表弹层中，切换报表数据的时候，需要调整栈数据
export function adjustHeaderConfig() {
    if (ifHidePopupNav()) {
        window.top.PopupHeaderConfig.splice(
            window.top.PopupHeaderConfig.length - 2,
            1
        );
    }
}

// 转换单位大小
export function convertSize(num, unit) {
    let size;
    switch (unit) {
        case 'GB':
            size = num * 1024 * 1024 * 1024;
            break;
        case 'MB':
            size = num * 1024 * 1024;
            break;
        case 'KB':
            size = num * 1024;
            break;
        default:
            size = num;
            break;
    }
    return size;
}

export function openUrlInNewWindow(params, url) {
    const title = params.title;
    const scaleEnabled = params.scaleEnabled || false;
    const screenOrientation = params.screenOrientation || false;
    url = urlCompletion(url);
    window.env.platform.select({
        beisenApp() {
            window.env.openNewPage({
                url: url,
                features: {
                    screenOrientation: screenOrientation,
                    scaleEnabled: scaleEnabled
                },
                navBar: {
                    options: {
                        titleItem: {
                            text: title
                        }
                    }
                }
            });
        },
        mobile() {
            if (window.env.platform.dingTalk) {
                openLinkInDingTalk(url);
                return;
            }
            window.open(url);
        }
    });
}

/**
 * 获取设备的横向物理像素
 */
export function getDevicePhysicPixelWidth() {
    // 图片压缩服务的白名单,只有白名单内的尺寸才会进行压缩
    const whiteList = [20, 60, 100, 640, 750, 1080, 1125, 1242];

    function getAdjacent(dWith) {
        let arr = [];
        whiteList.map(w => {
            arr.push(Math.abs(dWith - w));
        });
        return whiteList[arr.indexOf(Math.min.apply(null, arr))];
    }

    // 设备真正的物理像素,有可能是小数也有可能不在白名单内
    const dWith = Math.round(window.screen.width * window.devicePixelRatio);

    return getAdjacent(dWith);
}

/**
 * 图片压缩需要重命名图片地址
 * 将 http://abc.com/bcd.jpg rename 为 http://abc.com/resize200/bcd.jpg
 * resize200 表示缩略到图片横向像素为200px 这个值根据设备的横向物理像素决定
 * @param picUrl 图片的原始地址
 * @param physicPixelWidth  物理像素大小
 */
export function picUrlRenaming(picUrl, physicPixelWidth) {
    physicPixelWidth = physicPixelWidth || getDevicePhysicPixelWidth();

    // 全局开关,表示是否开启压缩服务
    if (!window.BSGlobal.supportPicCompression) {
        return picUrl;
    }

    if (picUrl.match(/resize\d+/)) {
        return (
            picUrl.replace(/resize\d+/, `resize${physicPixelWidth}`) +
            `?ramdom=${new Date().getMilliseconds()}`
        );
    }
    const hostArr = window.location.hostname.split('.');
    const splitFlag = picUrl.split('/').filter(item => {
        return (
            item.includes(hostArr[hostArr.length - 1]) &&
            item.includes(hostArr[hostArr.length - 2])
        );
    });
    if (splitFlag.length) {
        return picUrl.replace(
            splitFlag,
            `${splitFlag}/resize${physicPixelWidth}`
        );
    } else {
        return picUrl;
    }
}

/**
 * 获取扩展导航颜色信息
 * @param {*} root 页面根节点数据
 */
export function getNavColorExtensionConfig(root) {
    if (isNotEmpty(root, ['cmp_data', 'configNavigation'])) {
        const configNavigation = root.cmp_data.configNavigation;
        return {
            color: configNavigation.color,
            bgColor: configNavigation.bgColor,
            titleColor:
                configNavigation.titleItem && configNavigation.titleItem.color
        };
    }
    return null;
}

/**
 * 获取扩展导航左侧回调函数
 * @param {*} root 页面根节点数据
 */
export function getNavLeftExtension(root) {
    if (isNotEmpty(root, ['cmp_data', 'configNavigation', 'leftItem'])) {
        let leftConfig = {};
        root.cmp_data.configNavigation.leftItem.forEach((item, index) => {
            const cb =
                (item.callback && item.callback.bind(this)) || function() {};
            leftConfig[item.type] = cb;
            item.type == 'close' &&
                (window.globalEventManager['handleClose'] = cb);
            item.type == 'back' &&
                (window.globalEventManager['handleBack'] = cb);
        });
        return leftConfig;
    }
    return null;
}

/**
 * 获取扩展导航右侧回调函数
 * @param {*} root 页面根节点数据
 * @param {String} pageName 当前页面的唯一标识 例如：详情页-> detail 视图页-> index
 */
export function genRightItemByExtensionNavConfig(root, pageName) {
    if (isNotEmpty(root, ['cmp_data', 'configNavigation', 'rightItem'])) {
        return root.cmp_data.configNavigation.rightItem.map((item, index) => {
            const cb =
                (item.callback && item.callback.bind(this)) || function() {};
            const cbName = `extension_${pageName}${index}`;
            if (!window.globalEventManager) {
                window.globalEventManager = {};
            }
            window.globalEventManager[cbName] = cb;
            if (item.text) {
                const style = Object.assign(
                    { color: item.color || '#ffffff' },
                    item.style
                );
                return (
                    <span
                        callback={cbName}
                        onTouchTap={cb}
                        style={style}
                        text={item.text}>
                        {item.text}
                    </span>
                );
            }
            if (
                window.env.platform.beisenApp &&
                item.icon === 'sys-icon-banci'
            ) {
                item.icon = 'history';
            }
            return (
                <Icon
                    icon={item.icon}
                    callback={cbName}
                    onTouchTap={cb}
                    style={{ color: item.color || '#ffffff' }}
                />
            );
        });
    }
    return null;
}

/**
 * 字符串首字母转大写
 * @param {string} 待转换的字符串
 * @return {string} 转换后的字符串
 */
export function capitalize([first, ...rest]) {
    return first.toUpperCase() + rest.join('');
}

export const innerErrorCodeMap = {
    //inner_302: '302',// 内部状态码 302 需要客户端跳转新页面
    inner_401: '401', // 内部状态码 401 这里什么都没有,页面内容为前端写死,图片是一个热气球
    inner_404: '404' // 内部状态码 404 页面内容为接口返回的message,图片是一个盒子
};

export const outerErrorCodeMap = {
    //417: '417',// http 状态码 417 接口自定义的错误,一般都是验证未通过,返回的错误,内部带有message,不需要一个错误页面进行展示,都是通过tip的形式展示的
    //439: '439',// http 状态码 439 服务端返回http code 为439 的时候,内部必然包含 302的code,标识需要前端做跳转
    outer_403: '403', // http 状态码 403 无权限 页面内容为前端写死,图片是一个盒子
    outer_404: '404', // http 状态码 404 没有找到资源 页面内容为前端写死,图片是一个小恐龙
    outer_500: '500' // http 状态码 500 服务器内部错误 页面内容为前端写死,图片为一个小恐龙
};

// 获取渲染错误页面类型
export const getErrorInfo = errors => {
    if (errors) {
        const innerCode = `${errors.code}`; // 接口自定义的内部code
        const outerCode = `${errors.status}`; // http 状态码
        const message = errors.message; // 接口自定义错误消息
        const innerError = [
            innerErrorCodeMap['inner_401'],
            innerErrorCodeMap['inner_404']
        ];
        const outerError = [
            outerErrorCodeMap['outer_403'],
            outerErrorCodeMap['outer_404'],
            outerErrorCodeMap['outer_500']
        ];
        if (innerError.includes(innerCode)) {
            return { message: message, errorType: `inner_${innerCode}` };
        }
        if (outerError.includes(outerCode)) {
            return { message: message, errorType: `outer_${outerCode}` };
        }
        return null;
    }
    return null;
};

export function deepClone(obj) {
    if (obj) {
        let str = JSON.stringify(obj);
        let newObj = JSON.parse(str);
        return newObj;
    } else {
        return {};
    }
}

export function parseUrlParams(url) {
    const queryIndex = url.indexOf('?');
    let urlParams = url;
    if (queryIndex !== -1) {
        urlParams = parseQueryParams(url.substring(queryIndex + 1));
    } else {
        urlParams = parseQueryParams(url);
    }
    return urlParams;
}
//当前是否处于elink链接访问
export function isElink() {
    if (typeof window.cloud_isElink === 'undefined') {
        let flag = false;
        const localHash = window.location.hash || '';
        let lindex = localHash.indexOf('?');
        const params = parseQueryParams(localHash.substring(lindex + 1)) || {};
        if (params.shadow_context) {
            flag = params.shadow_context.indexOf('elinkId') > -1;
        }
        window.cloud_isElink = flag;
    }

    return window.cloud_isElink;
}
//是否为安卓微信
export const isAndroidWeixin = () => {
    let pEnvPlatform = getEnv().platform || {};
    return pEnvPlatform.android && pEnvPlatform.weixin;
};
//为BasePage相关列表，相关的链接添加参数
export const getBasePageModuleUrl = (queryUrl = {}) => {
    const {
        fromURL,
        pObjectDataID,
        viewName,
        metaObjName,
        showMenu,
        showBack,
        viewpath,
        detailViewName,
        currentDetailPageViewName,
        mainDetailViewName,
        moduleID,
        formState,
        shadow_context,
        id
    } = queryUrl;
    return `#/BasePage?metaKey=${guid()}&formState=${formState}&fromURL=${fromURL}&pObjectDataID=${pObjectDataID}&viewName=${viewName}&metaObjName=${metaObjName}&showMenu=${showMenu}&showBack=${showBack}&viewpath=${viewpath}&detailViewName=${detailViewName}&currentDetailPageViewName=${currentDetailPageViewName}&mainDetailViewName=${mainDetailViewName}&moduleID=${moduleID}&shadow_context=${shadow_context}&id=${id}`;
};

// 当语言是英文的时候，返回对应布局，否则返回null
export const getStyleTitleByLang = styleTitleEN =>
    BSGlobal.I18NInfo && BSGlobal.I18NInfo.I18NUserLang === 'en_US'
        ? styleTitleEN
        : null;



// WEBPACK FOOTER //
// ./src/components/util/helper.js